import { CALL_API, Schemas } from '../../common/middleware/api';

export const APPS_REQUEST = 'APPS_REQUEST';
export const APPS_SUCCESS = 'APPS_SUCCESS';
export const APPS_FAILURE = 'APPS_FAILURE';

export const APP_FETCH_REQUEST = 'APP_GET_REQUEST';
export const APP_FETCH_SUCCESS = 'APP_GET_SUCCESS';
export const APP_FETCH_FAILURE = 'APP_GET_FAILURE';

export const APP_CREATE_REQUEST = 'APP_CREATE_REQUEST';
export const APP_CREATE_SUCCESS = 'APP_CREATE_SUCCESS';
export const APP_CREATE_FAILURE = 'APP_CREATE_FAILURE';

export const APP_UPDATE_REQUEST = 'APP_UPDATE_REQUEST';
export const APP_UPDATE_SUCCESS = 'APP_UPDATE_SUCCESS';
export const APP_UPDATE_FAILURE = 'APP_UPDATE_FAILURE';

export const loadApps = (options) => ({
	[CALL_API]: {
		types: [APPS_REQUEST, APPS_SUCCESS, APPS_FAILURE],
		endpoint: 'api/apps',
		request: options,
		schema: Schemas.APP_ARRAY
	}
});

export const fetchApp = (id) => ({
	[CALL_API]: {
		types: [APP_FETCH_REQUEST, APP_FETCH_SUCCESS, APP_FETCH_FAILURE],
		endpoint: `api/apps/${id}`,
		schema: Schemas.APP
	}
});

export const createApp = (app, history) => ({
	[CALL_API]: {
		types: [APP_CREATE_REQUEST, APP_CREATE_SUCCESS, APP_CREATE_FAILURE],
		endpoint: 'api/apps',
		method: 'POST',
		request: app,
		schema: Schemas.APP,
		form: 'app',
		transition: {
			history,
			successPath: (response) => {
				return `/apps/${response.result}`;
			}
		}
	}
});

export const updateApp = (id, app) => ({
	[CALL_API]: {
		types: [APP_UPDATE_REQUEST, APP_UPDATE_SUCCESS, APP_UPDATE_FAILURE],
		endpoint: `api/apps/${id}`,
		method: 'PUT',
		request: app,
		schema: Schemas.APP,
		form: 'app'
	}
});